export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11907.39adc899.jpg";